/* eslint-disable */
const MODES = { DRAW: 'draw', ERASE: 'erase' };
const TOOLBAR_HEIGHT = 80;
const MIN_SCALE = 0.2;
const MAX_SCALE = 3.0;
const IMG_SRC = 'https://quantumtrader.s3.amazonaws.com/fsdemo.png';

let isInitialRender = true;
let canvas, context, bgCanvas, bgContext;
let activeMode = MODES.DRAW;
let drawings = [];
let scale = 1;
let cursorX, cursorY, prevCursorX, prevCursorY;
let offsetX = 0, offsetY = 0;
let backgroundImage;

function constrainOffset() {
  // Get current scaled image dimensions
  const scaledImgWidth = backgroundImage.width * scale;
  const scaledImgHeight = backgroundImage.height * scale;
  
  // Calculate maximum allowed offsets that keep at least 10% of image visible
  const minVisibleAmount = 0.1; // 10% of image must stay visible
  
  // Calculate boundaries
  const minOffsetX = -(scaledImgWidth/scale) * (1 - minVisibleAmount);
  const maxOffsetX = canvas.width/scale * (1 - minVisibleAmount);
  const minOffsetY = -(scaledImgHeight/scale) * (1 - minVisibleAmount);
  const maxOffsetY = canvas.height/scale * (1 - minVisibleAmount);

  // Constrain offsetX
  offsetX = Math.min(maxOffsetX, Math.max(minOffsetX, offsetX));
  
  // Constrain offsetY, accounting for toolbar
  offsetY = Math.min(maxOffsetY, Math.max(minOffsetY, offsetY));
}

export function _initializeCanvas(mainCanvas, backgroundCanvas, imgSrc = IMG_SRC, userDrawings = [], notifyReact) {
  drawings = userDrawings;
  canvas = mainCanvas;
  context = canvas.getContext('2d');

  bgCanvas = backgroundCanvas;
  bgContext = bgCanvas.getContext('2d');

  // Adjust canvas height
  canvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;
  bgCanvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;

  // Canvas background image
  backgroundImage = new Image();
  backgroundImage.src = imgSrc;
  console.log('Loading background image....');
  // console.log(imgSrc);
  backgroundImage.onload = function () {
    bgContext.drawImage(backgroundImage, 0, 0);
    console.log('background image loaded!!!');
    if (notifyReact) {
      notifyReact('background image loaded!!!');
    }
  }

  // --------------------------------------------------
  // Event Handling
  // --------------------------------------------------

  // Disable right click on canvas
  document.oncontextmenu = function () { return false; }
  window.addEventListener("resize", () => { redrawCanvas(); });

  canvas.addEventListener('mousedown', onMouseDown);
  canvas.addEventListener('mouseup', onMouseUp, false);
  canvas.addEventListener('mouseout', onMouseUp, false);
  canvas.addEventListener('mousemove', onMouseMove, false);
  canvas.addEventListener('wheel', onMouseWheel, false);
  canvas.addEventListener('touchstart', onTouchStart);
  canvas.addEventListener('touchend', onTouchEnd);
  canvas.addEventListener('touchcancel', onTouchEnd);
  canvas.addEventListener('touchmove', onTouchMove);

  redrawCanvas();
}

export function __initializeCanvas(mainCanvas, backgroundCanvas, imgSrc = IMG_SRC, userDrawings = [], notifyReact) {
  isFirstRender = true;
  drawings = userDrawings;
  canvas = mainCanvas;
  context = canvas.getContext('2d');
  bgCanvas = backgroundCanvas;
  bgContext = bgCanvas.getContext('2d');

  canvas.width = document.body.clientWidth;
  canvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;
  bgCanvas.width = document.body.clientWidth;
  bgCanvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;

  backgroundImage = new Image();
  backgroundImage.src = imgSrc;

  backgroundImage.onload = function () {
    // Center the image
    offsetX = (canvas.width - backgroundImage.width) / (2 * scale);
    offsetY = (canvas.height - backgroundImage.height) / (2 * scale);

    redrawCanvas();

    if (notifyReact) {
      notifyReact('background image loaded!!!');
    }
  }

  // Disable right click on canvas
  document.oncontextmenu = function () { return false; }

  window.addEventListener("resize", () => { redrawCanvas(); });

  canvas.addEventListener('mousedown', onMouseDown);
  canvas.addEventListener('mouseup', onMouseUp, false);
  canvas.addEventListener('mouseout', onMouseUp, false);
  canvas.addEventListener('mousemove', onMouseMove, false);
  canvas.addEventListener('wheel', onMouseWheel, false);
  canvas.addEventListener('touchstart', onTouchStart);
  canvas.addEventListener('touchend', onTouchEnd);
  canvas.addEventListener('touchcancel', onTouchEnd);
  canvas.addEventListener('touchmove', onTouchMove);

  redrawCanvas();
}

export function initializeCanvas(mainCanvas, backgroundCanvas, imgSrc = IMG_SRC, userDrawings = [], notifyReact) {
  drawings = userDrawings;
  canvas = mainCanvas;
  context = canvas.getContext('2d');
  bgCanvas = backgroundCanvas; 
  bgContext = bgCanvas.getContext('2d');

  // Reset initial render flag
  isInitialRender = true;

  canvas.width = document.body.clientWidth;
  canvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;
  bgCanvas.width = document.body.clientWidth;
  bgCanvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;

  backgroundImage = new Image();
  backgroundImage.src = imgSrc;

  backgroundImage.onload = function() {
    // Initial centering will be handled in redrawCanvas
    redrawCanvas();

    if (notifyReact) {
      notifyReact('background image loaded!!!');
    }
  }

  // Rest of the initialization code remains the same
  document.oncontextmenu = function() { return false; }
  window.addEventListener("resize", () => { redrawCanvas(); });
  canvas.addEventListener('mousedown', onMouseDown);
  canvas.addEventListener('mouseup', onMouseUp, false);
  canvas.addEventListener('mouseout', onMouseUp, false);
  canvas.addEventListener('mousemove', onMouseMove, false);
  canvas.addEventListener('wheel', onMouseWheel, false);
  canvas.addEventListener('touchstart', onTouchStart);
  canvas.addEventListener('touchend', onTouchEnd);
  canvas.addEventListener('touchcancel', onTouchEnd);
  canvas.addEventListener('touchmove', onTouchMove);
}

export function destroyCanvas() {
  window.removeEventListener("resize", redrawCanvas);
  canvas.removeEventListener('mousedown', onMouseDown);
  canvas.removeEventListener('mouseup', onMouseUp);
  canvas.removeEventListener('mouseout', onMouseUp);
  canvas.removeEventListener('mousemove', onMouseMove);
  canvas.removeEventListener('wheel', onMouseWheel);
  canvas.removeEventListener('touchstart', onTouchStart);
  canvas.removeEventListener('touchend', onTouchEnd);
  canvas.removeEventListener('touchcancel', onTouchEnd);
  canvas.removeEventListener('touchmove', onTouchMove);

  const ctx = canvas.getContext("2d");
  const bgCtx = bgCanvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  bgCtx.clearRect(0, 0, bgCanvas.width, bgCanvas.height);
}

export function setDrawMode(mode) {
  console.log(`Setting mode to ${mode}`);
  activeMode = mode;
}

export function getUserDrawings() {
  return drawings;
}

// --------------------------------------------------
// Utility functions
// --------------------------------------------------
function toScreenX(xTrue) { return (xTrue + offsetX) * scale; }

// function toScreenY(yTrue) { return (yTrue + offsetY) * scale; }
function toScreenY(yTrue) {
  return (yTrue + offsetY) * scale + TOOLBAR_HEIGHT;
}

function toTrueX(xScreen) { return (xScreen / scale) - offsetX; }

// function toTrueY(yScreen) { return (yScreen / scale) - offsetY; }
function toTrueY(yScreen) { return ((yScreen - TOOLBAR_HEIGHT) / scale) - offsetY; }

// function trueHeight() { return canvas.clientHeight / scale; }
function trueHeight() { return (canvas.clientHeight - TOOLBAR_HEIGHT) / scale; }

function trueWidth() { return canvas.clientWidth / scale; }

function isWithinBounds(x, y) {
  const trueX = toTrueX(x);
  const trueY = toTrueY(y);
  return trueX >= 0 && trueX <= backgroundImage.width &&
    trueY >= 0 && trueY <= backgroundImage.height;
}

// --------------------------------------------------
// Drawing functions
// --------------------------------------------------
export function _redrawCanvas() {
  canvas.width = document.body.clientWidth;
  canvas.height = document.body.clientHeight;
  canvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;

  // bgCanvas.width = document.body.clientWidth;
  // bgCanvas.height = document.body.clientHeight;
  // bgContext.drawImage(backgroundImage, toScreenX(0), toScreenY(0), backgroundImage.width * scale, backgroundImage.height * scale);
  bgCanvas.width = document.body.clientWidth;
  // bgCanvas.height = document.body.clientHeight;
  bgCanvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;
  bgContext.drawImage(backgroundImage, toScreenX(0), toScreenY(0), backgroundImage.width * scale, backgroundImage.height * scale);

  context.clearRect(0, 0, canvas.width, canvas.height);

  for (let i = 0; i < drawings.length; i++) {
    const line = drawings[i];
    if (line.type === 'draw') {
      drawLine(toScreenX(line.x0), toScreenY(line.y0), toScreenX(line.x1), toScreenY(line.y1));
    } else {
      const erase = drawings[i];
      eraseLine(toScreenX(erase.x0), toScreenY(erase.y0), toScreenX(erase.x1), toScreenY(erase.y1));
    }
  }
}

export function __redrawCanvas() {
  // Reset canvas dimensions
  canvas.width = document.body.clientWidth;
  canvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;
  bgCanvas.width = document.body.clientWidth;
  bgCanvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;

  // Clear canvases
  bgContext.clearRect(0, 0, bgCanvas.width, bgCanvas.height);
  context.clearRect(0, 0, canvas.width, canvas.height);

  // Draw background image centered
  const scaledImgWidth = backgroundImage.width * scale;
  const scaledImgHeight = backgroundImage.height * scale;

  bgContext.drawImage(
    backgroundImage,
    toScreenX(0),
    toScreenY(0),
    scaledImgWidth,
    scaledImgHeight
  );

  // Redraw all drawings
  for (const line of drawings) {
    if (line.type === 'draw') {
      drawLine(
        toScreenX(line.x0),
        toScreenY(line.y0),
        toScreenX(line.x1),
        toScreenY(line.y1)
      );
    } else {
      eraseLine(
        toScreenX(line.x0),
        toScreenY(line.y0),
        toScreenX(line.x1),
        toScreenY(line.y1)
      );
    }
  }
}

export function ___redrawCanvas() {
  // Reset canvas dimensions
  canvas.width = document.body.clientWidth;
  canvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;
  bgCanvas.width = document.body.clientWidth;
  bgCanvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;

  // Clear canvases
  bgContext.clearRect(0, 0, bgCanvas.width, bgCanvas.height);
  context.clearRect(0, 0, canvas.width, canvas.height);

  // Calculate scaled dimensions while maintaining aspect ratio
  const containerWidth = canvas.width;
  const containerHeight = canvas.height;
  const imageAspectRatio = backgroundImage.width / backgroundImage.height;
  const containerAspectRatio = containerWidth / containerHeight;

  let scaledImgWidth, scaledImgHeight;

  // Determine scale based on container constraints
  let fitScale = scale;
  if (imageAspectRatio > containerAspectRatio) {
    // Image is wider relative to container - fit to width
    scaledImgWidth = containerWidth;
    scaledImgHeight = containerWidth / imageAspectRatio;
    // Calculate required scale
    const widthScale = containerWidth / backgroundImage.width;
    if (scale > widthScale) {
      fitScale = widthScale;
    }
  } else {
    // Image is taller relative to container - fit to height 
    scaledImgHeight = containerHeight;
    scaledImgWidth = containerHeight * imageAspectRatio;
    // Calculate required scale
    const heightScale = containerHeight / backgroundImage.height;
    if (scale > heightScale) {
      fitScale = heightScale;
    }
  }

  // Apply the fitted scale
  scaledImgWidth = backgroundImage.width * fitScale;
  scaledImgHeight = backgroundImage.height * fitScale;

  // Update global scale if it was adjusted
  if (fitScale !== scale) {
    scale = fitScale;
  }

  // Center the image
  offsetX = (containerWidth - scaledImgWidth) / (2 * scale);
  offsetY = (containerHeight - scaledImgHeight) / (2 * scale);

  // Draw background image
  bgContext.drawImage(
    backgroundImage,
    toScreenX(0),
    toScreenY(0),
    scaledImgWidth,
    scaledImgHeight
  );

  // Redraw all drawings
  for (const line of drawings) {
    if (line.type === 'draw') {
      drawLine(
        toScreenX(line.x0),
        toScreenY(line.y0),
        toScreenX(line.x1),
        toScreenY(line.y1)
      );
    } else {
      eraseLine(
        toScreenX(line.x0),
        toScreenY(line.y0),
        toScreenX(line.x1),
        toScreenY(line.y1)
      );
    }
  }
}

export function redrawCanvas() {
  // Reset canvas dimensions
  canvas.width = document.body.clientWidth;
  canvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;
  bgCanvas.width = document.body.clientWidth;
  bgCanvas.height = document.body.clientHeight - TOOLBAR_HEIGHT;

  // Clear canvases
  bgContext.clearRect(0, 0, bgCanvas.width, bgCanvas.height);
  context.clearRect(0, 0, canvas.width, canvas.height);

  if (isInitialRender) {
    // Calculate initial scale and position to fit and center the image
    const containerWidth = canvas.width;
    const containerHeight = canvas.height;
    const imageAspectRatio = backgroundImage.width / backgroundImage.height;
    const containerAspectRatio = containerWidth / containerHeight;

    // Calculate initial scale to fit
    if (imageAspectRatio > containerAspectRatio) {
      // Image is wider - fit to width
      scale = containerWidth / backgroundImage.width;
    } else {
      // Image is taller - fit to height
      scale = containerHeight / backgroundImage.height;
    }

    // Apply scale limits
    scale = Math.min(Math.max(scale, MIN_SCALE), MAX_SCALE);

    // Calculate centered position
    const scaledImgWidth = backgroundImage.width * scale;
    const scaledImgHeight = backgroundImage.height * scale;
    offsetX = (containerWidth - scaledImgWidth) / (2 * scale);
    // offsetY = (containerHeight - scaledImgHeight) / (2 * scale);
    offsetY = -80;

    console.log(`offsetY = ${offsetY}`);

    // Reset the flag after initial render
    isInitialRender = false;
  }

  // Draw background image with current scale and offset
  const scaledImgWidth = backgroundImage.width * scale;
  const scaledImgHeight = backgroundImage.height * scale;

  // const toScreenYInit = (yTrue) => {
  //   return (yTrue + offsetY) * scale + TOOLBAR_HEIGHT;
  // }

  bgContext.drawImage(
    backgroundImage,
    toScreenX(0),
    toScreenY(0),
    scaledImgWidth,
    scaledImgHeight
  );

  // Redraw all drawings
  for (const line of drawings) {
    if (line.type === 'draw') {
      drawLine(
        toScreenX(line.x0),
        toScreenY(line.y0),
        toScreenX(line.x1),
        toScreenY(line.y1)
      );
    } else {
      eraseLine(
        toScreenX(line.x0),
        toScreenY(line.y0),
        toScreenX(line.x1),
        toScreenY(line.y1)
      );
    }
  }
}

function drawLine(x0, y0, x1, y1) {
  if (isWithinBounds(x0, y0) && isWithinBounds(x1, y1)) {
    context.beginPath();
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    // context.strokeStyle = '#00A0FF';
    context.strokeStyle = '#0163d6';
    context.lineWidth = 2;
    context.stroke();
  }
}

function eraseLine(x0, y0, x1, y1) {
  if (isWithinBounds(x0, y0) && isWithinBounds(x1, y1)) {
    context.save();
    context.globalCompositeOperation = 'destination-out';
    context.beginPath();
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.strokeStyle = 'rgba(0,0,0,1)';
    context.lineWidth = 30 * scale;
    // context.lineWidth = 10 * scale;
    context.stroke();
    context.restore();
  }
}

// --------------------------------------------------
// Mouse Events
// --------------------------------------------------
let leftMouseDown = false;
let rightMouseDown = false;

function onMouseDown(event) {
  if (event.button == 0) {
    leftMouseDown = true;
    rightMouseDown = false;
  }
  if (event.button == 2) {
    rightMouseDown = true;
    leftMouseDown = false;
  }

  cursorX = event.pageX;
  prevCursorX = event.pageX;
  // cursorY = event.pageY;
  cursorY = event.pageY - TOOLBAR_HEIGHT;
  // prevCursorY = event.pageY;
  prevCursorY = event.pageY - TOOLBAR_HEIGHT;
}

function _onMouseMove(event) {
  // cursorX = event.pageX;
  // cursorY = event.pageY;
  cursorX = event.pageX;
  cursorY = event.pageY - TOOLBAR_HEIGHT;
  const scaledX = toTrueX(cursorX);
  const scaledY = toTrueY(cursorY);
  const prevScaledX = toTrueX(prevCursorX);
  const prevScaledY = toTrueY(prevCursorY);

  if (leftMouseDown) {
    if (activeMode === MODES.DRAW) {
      drawings.push({
        x0: prevScaledX,
        y0: prevScaledY,
        x1: scaledX,
        y1: scaledY,
        type: 'draw'
      });
      context.lineCap = 'round';
      drawLine(prevCursorX, prevCursorY, cursorX, cursorY);
    } else if (activeMode === MODES.ERASE) {
      drawings.push({
        x0: prevScaledX,
        y0: prevScaledY,
        x1: scaledX,
        y1: scaledY,
        type: 'erase'
      });
      eraseLine(prevCursorX, prevCursorY, cursorX, cursorY);
      // Applying intersection algo
      // const currentErasing = {
      //   x0: prevScaledX,
      //   y0: prevScaledY,
      //   x1: scaledX,
      //   y1: scaledY
      // };
      // erasings.push(currentErasing);
      // eraseLine(prevCursorX, prevCursorY, cursorX, cursorY);
      // // Find intersections between the current erasing and drawings
      // const intersections = [];
      // for (let i = drawings.length - 1; i >= 0; i--) {
      //   const drawing = drawings[i];
      //   if (intersects(currentErasing, drawing, ERASE_SENSITIVITY)) {
      //     console.log('intersection found!');
      //     intersections.push(drawing);
      //     // drawings.splice(i, 1);
      //   }
      // }
      // erasings = [];
      // drawings = drawings.filter(drawing => !intersections.some(intersection => intersects(drawing, intersection, ERASE_SENSITIVITY)));
    }
  }
  if (rightMouseDown) {
    offsetX += (cursorX - prevCursorX) / scale;
    offsetY += (cursorY - prevCursorY) / scale;
    redrawCanvas();
  }
  prevCursorX = cursorX;
  prevCursorY = cursorY;
}

function onMouseMove(event) {
  cursorX = event.pageX;
  cursorY = event.pageY - TOOLBAR_HEIGHT;
  const scaledX = toTrueX(cursorX);
  const scaledY = toTrueY(cursorY);
  const prevScaledX = toTrueX(prevCursorX);
  const prevScaledY = toTrueY(prevCursorY);

  if (leftMouseDown) {
    if (activeMode === MODES.DRAW) {
      drawings.push({
        x0: prevScaledX,
        y0: prevScaledY,
        x1: scaledX,
        y1: scaledY,
        type: 'draw'
      });
      context.lineCap = 'round';
      drawLine(prevCursorX, prevCursorY, cursorX, cursorY);
    } else if (activeMode === MODES.ERASE) {
      drawings.push({
        x0: prevScaledX,
        y0: prevScaledY,
        x1: scaledX,
        y1: scaledY,
        type: 'erase'
      });
      eraseLine(prevCursorX, prevCursorY, cursorX, cursorY);
    }
  }
  if (rightMouseDown) {
    offsetX += (cursorX - prevCursorX) / scale;
    offsetY += (cursorY - prevCursorY) / scale;
    constrainOffset(); // Add constraint check
    redrawCanvas();
  }
  prevCursorX = cursorX;
  prevCursorY = cursorY;
}

function onMouseUp() {
  leftMouseDown = false;
  rightMouseDown = false;
}

function onMouseWheel(event) {
  const deltaY = event.deltaY;
  const scaleAmount = -deltaY / 500;
  scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, scale * (1 + scaleAmount)));

  var distX = event.pageX / canvas.clientWidth;
  // var distY = event.pageY / canvas.clientHeight;
  var distY = (event.pageY - TOOLBAR_HEIGHT) / canvas.clientHeight;

  const unitsZoomedX = trueWidth() * scaleAmount;
  const unitsZoomedY = trueHeight() * scaleAmount;

  const unitsAddLeft = unitsZoomedX * distX;
  const unitsAddTop = unitsZoomedY * distY;

  offsetX -= unitsAddLeft;
  offsetY -= unitsAddTop;

  redrawCanvas();
}

// --------------------------------------------------
// Touch Events
// --------------------------------------------------
const prevTouches = [null, null];
let singleTouch = false;
let doubleTouch = false;

function onTouchStart(event) {
  if (event.preventDefault) {
    event.preventDefault();
  }

  if (event.touches.length == 1) {
    singleTouch = true;
    doubleTouch = false;
  }
  if (event.touches.length >= 2) {
    singleTouch = false;
    doubleTouch = true;
  }

  prevTouches[0] = event.touches[0];
  prevTouches[1] = event.touches[1];
}

function _onTouchMove(event) {
  // const touch0X = event.touches[0].pageX;
  // const touch0Y = event.touches[0].pageY;
  // const prevTouch0X = prevTouches[0].pageX;
  // const prevTouch0Y = prevTouches[0].pageY;
  const touch0X = event.touches[0].pageX;
  const touch0Y = event.touches[0].pageY - TOOLBAR_HEIGHT;
  const prevTouch0X = prevTouches[0].pageX;
  const prevTouch0Y = prevTouches[0].pageY - TOOLBAR_HEIGHT;

  const scaledX = toTrueX(touch0X);
  const scaledY = toTrueY(touch0Y);
  const prevScaledX = toTrueX(prevTouch0X);
  const prevScaledY = toTrueY(prevTouch0Y);

  if (singleTouch) {
    if (activeMode === MODES.DRAW) {
      drawings.push({
        type: 'draw',
        x0: prevScaledX,
        y0: prevScaledY,
        x1: scaledX,
        y1: scaledY
      });
      drawLine(prevTouch0X, prevTouch0Y, touch0X, touch0Y);
    } else if (activeMode === MODES.ERASE) {
      drawings.push({
        type: 'erase',
        x0: prevScaledX,
        y0: prevScaledY,
        x1: scaledX,
        y1: scaledY
      });
      eraseLine(prevTouch0X, prevTouch0Y, touch0X, touch0Y);
    }
  }

  if (doubleTouch) {
    const touch1X = event.touches[1].pageX;
    const touch1Y = event.touches[1].pageY;
    const prevTouch1X = prevTouches[1].pageX;
    const prevTouch1Y = prevTouches[1].pageY;

    const midX = (touch0X + touch1X) / 2;
    const midY = (touch0Y + touch1Y) / 2;
    const prevMidX = (prevTouch0X + prevTouch1X) / 2;
    const prevMidY = (prevTouch0Y + prevTouch1Y) / 2;

    const hypot = Math.sqrt(Math.pow((touch0X - touch1X), 2) + Math.pow((touch0Y - touch1Y), 2));
    const prevHypot = Math.sqrt(Math.pow((prevTouch0X - prevTouch1X), 2) + Math.pow((prevTouch0Y - prevTouch1Y), 2));

    var zoomAmount = hypot / prevHypot;
    scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, scale * zoomAmount));
    const scaleAmount = 1 - zoomAmount;

    const panX = midX - prevMidX;
    const panY = midY - prevMidY;
    offsetX += (panX / scale);
    offsetY += (panY / scale);

    var zoomRatioX = midX / canvas.clientWidth;
    var zoomRatioY = midY / canvas.clientHeight;

    const unitsZoomedX = trueWidth() * scaleAmount;
    const unitsZoomedY = trueHeight() * scaleAmount;

    const unitsAddLeft = unitsZoomedX * zoomRatioX;
    const unitsAddTop = unitsZoomedY * zoomRatioY;

    offsetX += unitsAddLeft;
    offsetY += unitsAddTop;

    redrawCanvas();
  }
  prevTouches[0] = event.touches[0];
  prevTouches[1] = event.touches[1];
}

function onTouchMove(event) {
  const touch0X = event.touches[0].pageX;
  const touch0Y = event.touches[0].pageY - TOOLBAR_HEIGHT;
  const prevTouch0X = prevTouches[0].pageX;
  const prevTouch0Y = prevTouches[0].pageY - TOOLBAR_HEIGHT;

  const scaledX = toTrueX(touch0X);
  const scaledY = toTrueY(touch0Y);
  const prevScaledX = toTrueX(prevTouch0X);
  const prevScaledY = toTrueY(prevTouch0Y);

  if (singleTouch) {
    if (activeMode === MODES.DRAW) {
      drawings.push({
        type: 'draw',
        x0: prevScaledX,
        y0: prevScaledY,
        x1: scaledX,
        y1: scaledY
      });
      drawLine(prevTouch0X, prevTouch0Y, touch0X, touch0Y);
    } else if (activeMode === MODES.ERASE) {
      drawings.push({
        type: 'erase',
        x0: prevScaledX,
        y0: prevScaledY,
        x1: scaledX,
        y1: scaledY
      });  
      eraseLine(prevTouch0X, prevTouch0Y, touch0X, touch0Y);
    }
  }

  if (doubleTouch) {
    const touch1X = event.touches[1].pageX;
    const touch1Y = event.touches[1].pageY - TOOLBAR_HEIGHT;
    const prevTouch1X = prevTouches[1].pageX;
    const prevTouch1Y = prevTouches[1].pageY - TOOLBAR_HEIGHT;

    const midX = (touch0X + touch1X) / 2;
    const midY = (touch0Y + touch1Y) / 2;
    const prevMidX = (prevTouch0X + prevTouch1X) / 2;
    const prevMidY = (prevTouch0Y + prevTouch1Y) / 2;

    const hypot = Math.sqrt(Math.pow((touch0X - touch1X), 2) + Math.pow((touch0Y - touch1Y), 2));
    const prevHypot = Math.sqrt(Math.pow((prevTouch0X - prevTouch1X), 2) + Math.pow((prevTouch0Y - prevTouch1Y), 2));

    var zoomAmount = hypot / prevHypot;
    scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, scale * zoomAmount));
    const scaleAmount = 1 - zoomAmount;

    const panX = midX - prevMidX;
    const panY = midY - prevMidY;
    offsetX += (panX / scale);
    offsetY += (panY / scale);

    var zoomRatioX = midX / canvas.clientWidth;
    var zoomRatioY = midY / canvas.clientHeight;

    const unitsZoomedX = trueWidth() * scaleAmount;
    const unitsZoomedY = trueHeight() * scaleAmount;

    const unitsAddLeft = unitsZoomedX * zoomRatioX;
    const unitsAddTop = unitsZoomedY * zoomRatioY;

    offsetX += unitsAddLeft;
    offsetY += unitsAddTop;

    constrainOffset(); // Add constraint check
    redrawCanvas();
  }
  
  prevTouches[0] = event.touches[0];
  prevTouches[1] = event.touches[1];
}

function onTouchEnd() {
  singleTouch = false;
  doubleTouch = false;
}